/* "Kauf N + N gratis" (Kollagen-Nachtmaske)
   - Ao adicionar ao carrinho um conjunto (variante 1, 2 ou 3), a página põe
     N × "1 Tube" (pago) + N × brinde, em vez da variante-pacote.
   - Mantém sempre os brindes = tubos pagos quando o carrinho muda
     (quantidade alterada, linha removida, carrinho antigo ao abrir a página).
   O tubo-brinde custa 0 € no produto (riscado 45 €).
   - Brinde extra (cfg.extra): com 3 ou mais tubos pagos entra 1 massageador facial
     (49 €), grátis pelo desconto automático "Geschenk: Gesichtsmassagegerät"
     (Compre X, ganhe Y: 3 tubos pagos = 1 massageador a 100 %). A Shopify não usa
     o mesmo tubo como condição de dois "Compre X, ganhe Y", por isso o tubo-brinde
     deixou de depender de desconto. Sai do carrinho quando os tubos pagos baixam.
   Configuração em snippets/lumivie-bogo-config.liquid. */
(function () {
  if (window.__lumivieBogo) return;
  window.__lumivieBogo = true;

  var cfg = null;
  try {
    var el = document.getElementById('lumivie-bogo-config');
    cfg = el ? JSON.parse(el.textContent) : null;
  } catch (e) {
    cfg = null;
  }
  if (!cfg || !cfg.unit || !cfg.gift || !cfg.sets) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ocupado = false;
  var espera = null;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function seccoes() {
    var d = drawer();
    if (!d || typeof d.getSectionsToRender !== 'function') return null;
    try {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      return null;
    }
  }

  function post(url, corpo) {
    var secs = seccoes();
    if (secs) {
      corpo.sections = secs;
      corpo.sections_url = window.location.pathname;
    }
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Fehler');
        return j;
      });
    });
  }

  // redesenha o carrinho lateral; só abre se pedido (ou se já estiver aberto)
  function mostrar(dados, abrir) {
    var d = drawer();
    if (!d || !dados || !dados.sections) {
      if (window.location.pathname.replace(/\/$/, '').slice(-5) === '/cart') window.location.reload();
      return;
    }
    d.classList.remove('is-empty');
    var aberto = d.classList.contains('active') || d.hasAttribute('open');
    if ((abrir || aberto) && typeof d.renderContents === 'function') {
      d.renderContents(dados);
    } else if (typeof d.getSectionsToRender === 'function') {
      d.getSectionsToRender().forEach(function (s) {
        var alvo = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        var html = dados.sections[s.id];
        if (!alvo || !html) return;
        if (typeof d.getSectionInnerHTML === 'function') {
          alvo.innerHTML = d.getSectionInnerHTML(html, s.selector);
        } else {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fonte = doc.querySelector(s.selector || '.shopify-section');
          if (fonte) alvo.innerHTML = fonte.innerHTML;
        }
      });
    }
    if (window.location.pathname.replace(/\/$/, '').slice(-5) === '/cart') window.location.reload();
  }

  // Não publicar 'cart-update': o tema responde redesenhando a gaveta com o HTML
  // da página do carrinho (main-cart-items), o que a deixa vazia. A gaveta e o
  // ícone já são redesenhados aqui com as secções da resposta.

  // o Shopify pode dividir um brinde em várias linhas (parte com desconto,
  // parte sem); acerta pela chave de cada linha: a 1.ª fica com o total e as
  // outras vão a 0. Sem linha nenhuma, usa o id da variante (update.js adiciona).
  function acertar(upd, linhas, variante, alvo) {
    if (!linhas.length) {
      if (alvo > 0) upd[variante] = alvo;
      return;
    }
    linhas.forEach(function (chave, i) {
      upd[chave] = i === 0 ? alvo : 0;
    });
  }

  // brindes = tubos pagos (+ brinde extra a partir de cfg.extra.min);
  // devolve a resposta do update (ou null se já estava certo)
  function ajustar() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pagos = 0;
        var brindes = 0;
        var linhas = [];
        var extras = 0;
        var linhasExtra = [];
        cart.items.forEach(function (it) {
          if (it.variant_id === cfg.unit) pagos += it.quantity;
          if (it.variant_id === cfg.gift) {
            brindes += it.quantity;
            linhas.push(it.key);
          }
          if (cfg.extra && it.variant_id === cfg.extra.variant) {
            extras += it.quantity;
            linhasExtra.push(it.key);
          }
        });
        var alvoExtra = cfg.extra && pagos >= cfg.extra.min ? cfg.extra.qty || 1 : 0;
        var upd = {};
        if (pagos !== brindes) acertar(upd, linhas, cfg.gift, pagos);
        if (cfg.extra && extras !== alvoExtra) acertar(upd, linhasExtra, cfg.extra.variant, alvoExtra);
        if (!Object.keys(upd).length) return null;
        return post('cart/update.js', { updates: upd });
      });
  }

  function sincronizar(abrir) {
    if (ocupado) return;
    ocupado = true;
    ajustar()
      .then(function (dados) {
        if (dados) {
          mostrar(dados, abrir);
        }
      })
      .catch(function () {})
      .then(function () {
        ocupado = false;
      });
  }

  function agendar() {
    clearTimeout(espera);
    espera = setTimeout(function () { sincronizar(false); }, 350);
  }

  // botão "In den Warenkorb" com um conjunto selecionado
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      var campo = form.querySelector('[name="id"]');
      var n = campo ? cfg.sets[String(campo.value)] : null;
      if (!n) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      if (ocupado) return;

      var q = parseInt(new FormData(form).get('quantity'), 10) || 1;
      var total = n * q;
      var pf = form.closest('product-form');
      var botao = form.querySelector('[type="submit"]');
      var spinner = botao ? botao.querySelector('.loading-overlay__spinner, .loading__spinner') : null;
      var erroBox = pf.querySelector('.product-form__error-message-wrapper');
      var erroTxt = pf.querySelector('.product-form__error-message');

      if (botao) {
        botao.setAttribute('aria-disabled', 'true');
        botao.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');
      if (erroBox) erroBox.setAttribute('hidden', '');

      ocupado = true;
      post('cart/add.js', {
        items: [
          { id: cfg.unit, quantity: total },
          { id: cfg.gift, quantity: total }
        ]
      })
        .then(function () {
          // se o carrinho já tinha tubos de antes, acerta os brindes; depois
          // desenha o carrinho com o carrinho completo
          return ajustar()
            .then(function (dadosAjuste) {
              return dadosAjuste || post('cart/update.js', { updates: {} });
            })
            .then(function (dados) {
              mostrar(dados, true);
            });
        })
        .catch(function (err) {
          if (erroTxt) erroTxt.textContent = err.message || 'Ein Fehler ist aufgetreten.';
          if (erroBox) erroBox.removeAttribute('hidden');
        })
        .then(function () {
          ocupado = false;
          if (botao) {
            botao.removeAttribute('aria-disabled');
            botao.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    },
    true
  );

  // mudanças no carrinho (tema e página do carrinho)
  if (typeof window.subscribe === 'function') {
    try {
      window.subscribe('cart-update', function (ev) {
        if (ev && ev.source === 'lumivie-bogo') return;
        agendar();
      });
    } catch (e) {}
  }

  // reserva: sempre que o conteúdo do carrinho lateral é redesenhado
  function observar() {
    var d = drawer();
    if (!d || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (!ocupado) agendar();
    }).observe(d, { childList: true, subtree: true });
  }

  function iniciar() {
    observar();
    sincronizar(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
